import ShowerCommon from "./showerCommon";
import {createParentPositions, ShowerHeadTypes} from "../../constants";

export default class ValveTrim extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'valve_trim';
    this.partName = 'Valve Trim';
    this.translateId = "visualizer.bathroom.shower.valve_trim";
    this.canBeDisabled = true;
    this.conflictingPositions = ["shower_seats"];
    if (isChild) {
      createParentPositions(this);
    }
  }

  handleClick() {
    this.setArmHeadType();
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_arm
  }
}
